/* eslint-disable react-refresh/only-export-components -- utilitários e constantes partilhados entre tabs */
import { Input, RadioGroup } from '@/design-system';
export const AUDIO_TRANSCRIPTION_FEATURE_KEY = 'audio_transcription';
export const ALICIA_TOKENS_FEATURE_KEY = 'alicia_tokens';

export const formatPrice = (valueCents: number, currency = 'BRL') =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(valueCents / 100);

/** Valor inicial em campo texto pt-BR (ex.: item já salvo em centavos). */
export const centsToBrlInput = (cents: number) =>
  (cents / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const intervalLabelPt = (interval: string | null | undefined) => {
  if (!interval) return '';
  const map: Record<string, string> = { month: '/mês', semester: '/semestre', year: '/ano' };
  return map[interval] ?? `/${interval}`;
};

export function UsageBar({ used, limit }: { used: number; limit: number | null }) {
  const pct = limit ? Math.min((used / limit) * 100, 100) : 0;
  const color = pct >= 90 ? 'bg-red-500' : pct >= 70 ? 'bg-amber-500' : 'bg-primary';
  return (
    <div className="h-1.5 w-full rounded-full bg-gray-100 overflow-hidden">
      <div className={`h-full rounded-full ${color} transition-all`} style={{ width: limit ? `${pct}%` : '100%' }} />
    </div>
  );
}

export const COMPANY_DETAIL_TABS = [
  { segment: 'overview' as const, label: 'Visão geral' },
  { segment: 'plans' as const, label: 'Plano' },
  { segment: 'members' as const, label: 'Usuários' },
  { segment: 'integrations' as const, label: 'Integrações' },
  { segment: 'ph24' as const, label: 'PH24' },
  { segment: 'connector' as const, label: 'Orya Connector' },
] as const;

export type CompanyDetailTabSegment = (typeof COMPANY_DETAIL_TABS)[number]['segment'];

export function ItemPriceOptions(props: {
  name: string;
  mode: 'catalog' | 'free' | 'custom';
  onMode: (m: 'catalog' | 'free' | 'custom') => void;
  customBrl: string;
  onCustomBrl: (v: string) => void;
}) {
  const { name, mode, onMode, customBrl, onCustomBrl } = props;
  return (
    <div className="flex flex-wrap items-center gap-3 text-sm">
      <RadioGroup
        label="Cobrança"
        value={mode}
        onChange={(value) => onMode(value as 'catalog' | 'free' | 'custom')}
        options={[
          { value: 'catalog', label: 'Catálogo' },
          { value: 'free', label: 'Cortesia (R$ 0)' },
          { value: 'custom', label: 'Preço customizado' },
        ]}
      />
      <input type="hidden" name={name} value="on" />
      {mode === 'custom' ? (
        <div className="w-28">
          <Input
            type="text"
            placeholder="Ex: 49,90"
            className="px-2 py-1"
            value={customBrl}
            onChange={(e) => onCustomBrl(e.target.value)}
          />
        </div>
      ) : null}
    </div>
  );
}
